import React from "react";

import Spinner from "../../../Spinner";
import FormGroup from "../../FormGroup";

import style from "../style.module.css"

export default function dropdownSpinner(props) {
    const { prompt, label, meta, disabled, required } = props;
    return (
        <FormGroup
            inputType="dropdown"
            meta={meta}
            label={label}
            disabled={disabled}
            required={required}
        >
            <div className={style.selectBox}>
                <span className={style.inputFetchingLabel} dangerouslySetInnerHTML={{ __html: label ? label : prompt }}></span>
                <div className={style.dropdownSpinner}>
                    <Spinner size="small" color="#000" />
                </div>
            </div>
        </FormGroup>
    )
}